import React from 'react';
import slugify from 'slugify';
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';

import { listLayoutProps } from './propTypes';

import listGroupers from './StateListGroupings';
import listRenderers from './ListRenderers';

configureAnchors({ scrollDuration: 300 });

function ListLayout({ frontmatter, infoSlug, stateInfos, infoFields, title }) {
  const listGrouper = listGroupers[frontmatter.stateListGrouping ?? 'default'];
  const groupedStates = listGrouper({
    stateInfos,
    frontmatter,
    infoSlug,
    infoFields,
  });
  return (
    <div>
      {title && (
        <ScrollableAnchor id={slugify(title.toLowerCase())}>
          <h2>{title}</h2>
        </ScrollableAnchor>
      )}
      <div className='mb-10 border-2 border-base-200 px-7 py-0 pt-5'>
        {groupedStates
          .filter((g) => g.states)
          .map((g) => (
            <div key={g.title}>
              <div>
                <strong>{g.title}</strong>
              </div>
              <div className='mb-5'>
                {g.states.map((state) => {
                  const stateName = state.fieldValue;
                  const stateSlug = slugify(stateName.toLowerCase());
                  return (
                    <a
                      href={`#${stateSlug}`}
                      key={stateSlug}
                      title={stateName}
                      className='my-3 mr-3 inline-block pl-0 text-base'
                    >
                      {stateName}
                    </a>
                  );
                })}
              </div>
            </div>
          ))}
      </div>
      {stateInfos.map((state) => {
        const stateName = state.fieldValue;
        const stateSlug = slugify(stateName.toLowerCase());

        const Renderer = listRenderers[frontmatter.listRenderer ?? 'default'];

        return (
          <ScrollableAnchor id={stateSlug} key={stateSlug}>
            <div
              key={stateSlug}
              className='border-2 border-base-200 p-7 odd:bg-base-200'
            >
              <h2>{`${stateName} ${frontmatter.stateTitleAppend}`}</h2>
              <Renderer
                state={state}
                frontmatter={frontmatter}
                infoSlug={infoSlug}
                stateInfos={stateInfos}
                infoFields={infoFields}
              />
            </div>
          </ScrollableAnchor>
        );
      })}
    </div>
  );
}

ListLayout.propTypes = listLayoutProps;

export default ListLayout;
